import { createSlice } from "@reduxjs/toolkit";
import { useGetAllDamageCause } from '../Hooks/index';
import uuid from 'react-uuid';






const initialState = {

    editMode: false,
    previousOrder: {},
    editeModeData: {
        orderSelected: {},
        sampleInformation: {},
        colorSelections: [],
        colorDuplicated: [],

        machineInfo: {},
        departmanDescriptions: [],
        addedDepartmanDescription: [],


        additionalColorsDuplicated: [],

        sampleInformationsImages: [],
        addedSampleInformationImages: [],

        damagesImage: [],
        addedDamageImage: [],

        orderUploadImages: [],
        addedOrderUploadImages: [],

        orderFormImages: [],
        addedFormImage: []
    }
    ,
    totalColors: [],
    countOfTotalColors: 0,

    printedInstanceImage: [],
    CustomerOrderFormImage: [],
    UploadImageFile: [],
    DamageImage: [],
    totalImages: [],

    klischeTypeName: [],
    customerNamesForOrder: [],
    customerSendInfoList: [],
    customerKlischeThikness: [],
    customerId: '',
    customerKlischeTypes: [],
    lpiList: [],


    organizationUnit: [],
    sepcialUnit: [],
    unitDescription: '',
    organizationUnitDescription: { forSend: [] },

    sampleInformation: {
        selectedDate: "",
        recipientUnitId: "",
        instanceCount: 0,
        instanceDescription: "",
        printedInstanceKeepStatusId: "",
        printedInstanceTypeId: "",
        uploadImages: []
    },

    formImagesData: [],



    customerMachinesInfo: {
        customerId: null,
        registredMachinesList: null,
        machineNameList: [],
        machineName: '',
        customerMachineDetails: {
            cylinderInfoList: [],
            aniloxInfoList: []
        }
        ,

        machineSelected: {
            lpiList: [],
            countOfColor: 0
        }
        ,
        orderMachineInfo: {
            orderNumber: '',
            machineInfoId: '',
            cylinderInfoId: '',
            orderAniluxes: []
        }

    },

    customerDesigner: {
        designerListName: []
    }
    ,
    orderViewData: {},

    aniloxOrderColorMerged: [],
    asyncOprationsMessages: {
        errors: [],
        success: []
    }
    ,
    addOrderSuccessData: null,
    orderColorsForAni: [],
    allMachineAnilox: [],
    machineAniloxSelected: [],
    customerslasticNumbers: [],
    customerDeliverInfoList: [],




    updateColorState: 0,

    orderCancelReasonStateInfo: {
        descriptions: '',
        state: 'off',
        status:'notDon',
        formLabel:'',
    
    },
    orderCancelData:{},

    orderDamageStatus:'',


}

const setOrderCancelData=(state, { payload })=>{
state.orderCancelData=payload;
}

const setOrderDamageStatus=(state,{ payload })=>{
    state.orderDamageStatus=payload;
}


const updateOrderCancelReasonInfo = (state, { payload }) => {
    state.orderCancelReasonStateInfo.descriptions = payload.descriptions;
    state.orderCancelReasonStateInfo.state = payload.state;
    state.orderCancelReasonStateInfo.status = payload.status;
    state.orderCancelReasonStateInfo.data = payload.data;
    state.orderCancelReasonStateInfo.formLabel = payload.formLabel;
    state.orderCancelReasonStateInfo.orderCancelReasonId = payload.orderCancelReasonId;


}







const setEditMode = (state) => {
    state.editMode = !state.editMode;
}


const filterOrderImages = ({ editeModeData }, { payload }) => {
    let { id, type } = payload;
    switch (type) {
        case 0:
            editeModeData.sampleInformationsImages = editeModeData.sampleInformationsImages.filter(img => img.id !== id)
            break;
        case 3:
            editeModeData.orderUploadImages = editeModeData.sampleInformationsImages.filter(img => img.id !== id)
            break;
        case 1:
            // console.log('from  this images type ')
            editeModeData.orderFormImages = editeModeData.orderFormImages.filter(img => img.id !== id)
            break;

        case 4:
            // console.log('from  this images type ')
            editeModeData.damagesImage = editeModeData.damagesImage.filter(img => img.id !== id)
            break;

    }
}

const filterAddedImages = (state, { payload }) => {
    let { id, type } = payload;
    // console.log(payload)
    if (state.editMode) {
        switch (type) {
            case 0:
                state.editeModeData.addedSampleInformationImages = state.editeModeData.addedSampleInformationImages.filter(img => img.id !== id)
                break;
            case 1:
                state.editeModeData.addedFormImage = state.editeModeData.addedFormImage.filter(img => img.id !== id)
                break;
            case 3:
                state.editeModeData.addedOrderUploadImages = state.editeModeData.addedOrderUploadImages.filter(img => img.id !== id)
                break;
            case 4:
                state.editeModeData.addedDamageImage = state.editeModeData.addedDamageImage.filter(img => img.id !== id)
                break;

            default:
                break;
        }
    } else {
        switch (type) {
            case 0:
                state.sampleInformation.uploadImages = state.sampleInformation.uploadImages.filter(img => img.id !== id)
                state.totalImages = state.totalImages.filter(img => img.id !== id)
                break;
            case 1:
                state.CustomerOrderFormImage = state.CustomerOrderFormImage.filter(img => img.id !== id)
                state.totalImages = state.totalImages.filter(img => img.id !== id)

                break;

            case 3:
                state.UploadImageFile = state.UploadImageFile.filter(img => img.id !== id)
                state.totalImages = state.totalImages.filter(img => img.id !== id)
                break;
            case 4:
                state.DamageImage = state.DamageImage.filter(img => img.id !== id)
                state.totalImages = state.totalImages.filter(img => img.id !== id)
                break;

            default:
                break;
        }
    }


}

const clearSampleInformationImages = (state) => {
    state.editeModeData.addedSampleInformationImages = [];
}

const clearAllAddedData = ({ editeModeData }) => {

    editeModeData.orderSelected = {};
    editeModeData.sampleInformation = {};
    editeModeData.colorSelections = [];
    editeModeData.colorDuplicated = [];
    editeModeData.machineInfo = {};
    editeModeData.additionalColorsDuplicated = [];


    editeModeData.addedSampleInformationImages = [];
    editeModeData.addedOrderUploadImages = [];
    editeModeData.addedFormImage = [];
    editeModeData.addedDamageImage = [];



}











const setOrderSelected = (state, { payload }) => {
    // console.log(payload.machineInfo)
    state.editeModeData.orderSelected = payload;
    state.editeModeData.sampleInformation = payload.printedInstanceTrace;
    state.editeModeData.colorSelections = payload.colorSelections;
    state.editeModeData.colorDuplicated = payload.colorSelections;
    state.editeModeData.additionalColorsDuplicated = payload.colorSelections.filter(color => color.isBase !== true);
    state.editeModeData.sampleInformationsImages = payload.uploadImages.filter(img => img.imageSelectType === 0);
    state.editeModeData.orderUploadImages = payload.uploadImages.filter(img => img.imageSelectType === 3);
    state.editeModeData.orderFormImages = payload.uploadImages.filter(img => img.imageSelectType === 1);
    state.editeModeData.damagesImage = payload.uploadImages.filter(img => img.imageSelectType === 4)




    //  orderUploadImages:[],
    // addedOrderUploadImages:[]




    state.editeModeData.machineInfo.machineInfoId = payload.machineInfoId;
    state.editeModeData.machineInfo.cylinderInfoId = payload.cylinderInfoId;
    state.editeModeData.machineInfo.orderAniloxes = payload.orderAniloxes;


    state.editeModeData.machineInfo = payload.machineInfo;

    state.editeModeData.departmanDescriptions = payload.unitsDescriptions



}

const addBasicColor = (state, { payload }) => {

    if (state.editMode) {
        // console.log(payload)
        state.editeModeData.colorSelections.forEach((colorItem) => {
            if (colorItem.colorValue === payload.colorValue && colorItem.countOfColor < 12) {

                colorItem.countOfColor += 1
                // console.log('editModeAdd')

            }
        })

    } else {
        state.BasicColor.forEach(colorItem => {
            if (colorItem.colorValue === payload.colorValue && colorItem.countOfColor < 12) {

                colorItem.countOfColor += 1
                // console.log('add mode Addeee')

            }
        });
        // console.log('add mode Addeee')
    }


}

const reduceBasicColor = (state, { payload }) => {



    if (state.editMode) {

        state.editeModeData.colorSelections.forEach((colorItem) => {
            if (colorItem.colorValue === payload.colorValue && colorItem.countOfColor > 0) {

                colorItem.countOfColor -= 1


            }
        })

    } else {
        state.BasicColor.forEach(colorItem => {
            if (colorItem.colorValue === payload.colorValue && colorItem.countOfColor > 0) {
                colorItem.countOfColor -= 1
            }
        })
    }




}



const addAdditionalColor = (state) => {

    if (state.editMode) {
        state.editeModeData.additionalColorsDuplicated = [...state.editeModeData.additionalColorsDuplicated, { id: uuid(), colorValue: '', countOfColor: 0, isBase: false }]
        // state.

    } else {
        if (state.additionalColor.length < 12) {
            state.additionalColor = [...state.additionalColor, { id: uuid(), colorValue: '', countOfColor: 0, isBase: false }]
        }
    }
}

const reduceAdditionalColor = (state, { payload }) => {
    if (state.editMode) {
        state.editeModeData.additionalColorsDuplicated = state.editeModeData.additionalColorsDuplicated.filter((color) => color.id !== payload)
    } else {
        // console.log(payload)
        state.additionalColor = state.additionalColor.filter((color) => color.id !== payload)
    }
}

const setValueAdditionalColor = (state, { payload }) => {
    // console.log(payload)

    if (state.editMode) {
        state.editeModeData.additionalColorsDuplicated.forEach((colorItem) => {
            if (colorItem.id === payload.id) {
                colorItem.colorValue = payload.valuee
            }
        })
    } else {
        state.additionalColor.forEach(colorItem => {
            if (colorItem.id === payload.id) {
                colorItem.colorValue = payload.valuee
            }
        })
    }





}

const addCountOfAdditionalColor = (state, { payload }) => {

    if (state.editMode) {
        state.editeModeData.additionalColorsDuplicated.forEach(colorItem => {
            if (colorItem.id === payload && colorItem.countOfColor < 12) {
                colorItem.countOfColor += 1
            }
        })

    } else {

        state.additionalColor.forEach(colorItem => {
            if (colorItem.id === payload && colorItem.countOfColor < 5) {
                colorItem.countOfColor += 1
            }
        })
    }

}

const reduceCountOfAdditionalColor = (state, { payload }) => {

    if (state.editMode) {
        state.editeModeData.additionalColorsDuplicated.forEach((colorItem) => {
            if (colorItem.id === payload && colorItem.countOfColor > 0) {
                colorItem.countOfColor -= 1
            }
        })
    } else {
        state.additionalColor.forEach((colorItem) => {
            if (colorItem.id === payload && colorItem.countOfColor > 0) {
                colorItem.countOfColor -= 1
            }
        })
    }


}

// editeModeData:{
//     orderSelected:{},
//     sampleInformation:{},
//     colorSelections:[]

const setTotalColors = (state, { payload }) => {

    if (state.editMode) {
        let baseColorFiltred = state.editeModeData.colorSelections.filter((color) => color.countOfColor !== 0 && color.colorValue !== "").filter(color => color.isBase === true);
        let additionalColorFilterd = state.editeModeData.additionalColorsDuplicated.filter(color => color.countOfColor !== 0);


        state.editeModeData.colorDuplicated = [...baseColorFiltred, ...additionalColorFilterd]

    } else {

        state.totalColors = [...state.BasicColor, ...state.additionalColor];
        state.totalColors = state.totalColors.filter((color) => color.countOfColor !== 0 && color.colorValue !== "");

        state.totalColors = state.totalColors.map((color) => {
            let { countOfColor, colorValue, isBase } = color;
            return { countOfColor, colorValue, isBase }
        })

        if (state.totalColors.length > 0) {
            var colorSum = state.totalColors.map(color => color.countOfColor).reduce((acc, amount) => acc + amount);
            // console.log(colorSum)
            state.countOfTotalColors = colorSum;

        }
    }

}





const setCustomerNamesForOrders = (state, { payload }) => {
    // console.log(payload,'from reduxxxxxxxxxxxx')
    state.customerNamesForOrder = payload

}


const setCustomerKlischeThikness = (state, { payload }) => {
    // console.log(payload, 'klisxhetikFromRedux')
}

const setCustomerKlischeTypes = (state, { payload }) => {
    // console.log(payload, 'klischeTypeFromRedux')
}

// state.additionalColor=[...state.additionalColor,{id:generateRandom(),colorValue:'',countOfColor:0,isBasic:false}]

const setImageFiles = (state, { payload }) => {
    const { type, data } = payload
    const arraydata = Array.from(data);
    // console.log(type)
    // console.log(arraydata)
    if (state.editMode) {

        switch (type) {
            case 0:
                state.editeModeData.addedSampleInformationImages = arraydata.map((file) => {
                    return { id: uuid(), picture: file, imageSelectType: 0, imageName: file.name, title: file.name, url: URL.createObjectURL(file) }


                })
                break;
            case 3:
                state.editeModeData.addedOrderUploadImages = arraydata.map((file) => {
                    return { id: uuid(), picture: file, imageSelectType: 0, imageName: file.name, title: file.name, url: URL.createObjectURL(file) }


                })
                break;

            case 1:
                state.editeModeData.addedFormImage = arraydata.map((file) => {
                    return { id: uuid(), picture: file, imageSelectType: 0, imageName: file.name, title: file.name, url: URL.createObjectURL(file) }


                })
                break;

            case 4:
                state.editeModeData.addedDamageImage = arraydata.map((file) => {
                    return { id: uuid(), picture: file, imageSelectType: 0, imageName: file.name, title: file.name, url: URL.createObjectURL(file) }


                })
                break;





            default:
                break;
        }
    } else {
        switch (type) {
            case 0:
                state.sampleInformation.uploadImages = arraydata.map((file) => {
                    return { id: uuid(), picture: file, imageSelectType: 0, imageName: file.name, title: file.name, url: URL.createObjectURL(file) }


                })
                break;

            case 1:
                state.CustomerOrderFormImage = arraydata.map((file) => {
                    return { id: uuid(), imageName: file.name, imageSelectType: 1, picture: file, title: file.name, url: URL.createObjectURL(file) }

                })
                state.totalImages = [...state.totalImages, ...state.CustomerOrderFormImage]
                break;


            case 3:
                state.UploadImageFile = arraydata.map((file) => {
                    return { id: uuid(), imageSelectType: 3, picture: file, imageName: file.name, title: file.name, url: URL.createObjectURL(file) }
                })

                state.totalImages = [...state.totalImages, ...state.UploadImageFile]
                break;

            case 4:
                state.DamageImage = arraydata.map((file) => {
                    return { id: uuid(), imageSelectType: 4, picture: file, imageName: file.name, title: file.name, url: URL.createObjectURL(file) }
                })

                state.totalImages = [...state.totalImages, ...state.DamageImage]
                break;


        }
    }







}


const deleteImage = (state, { payload }) => {
    // console.log(payload)
    const { id, type } = payload;
    if (state.editMode) {
        // console.log('ihhihihihi')
    } else {
        switch (type) {
            case 0:
                state.printedInstanceImage = state.printedInstanceImage.filter(img => img.id !== id)
                state.totalImages = state.totalImages.filter(img => img.id !== id)
                break;
            case 1:
                state.CustomerOrderFormImage = state.CustomerOrderFormImage.filter(img => img.id !== id)
                state.totalImages = state.totalImages.filter(img => img.id !== id)

                break;

            case 3:
                state.UploadImageFile = state.UploadImageFile.filter(img => img.id !== id)
                state.totalImages = state.totalImages.filter(img => img.id !== id)
                break;
            case 4:
                state.DamageImage = state.DamageImage.filter(img => img.id !== id)
                state.totalImages = state.totalImages.filter(img => img.id !== id)
                break;

            default:
                break;
        }
    }

    //   state.imagesFiles=state.imagesFiles.filter(img=>img.id!=payload)

}

const clearAll = (state) => {
    state.totalColors = [];
    state.BasicColor.forEach((color) => {
        color.countOfColor = 0;
    })
    state.countOfTotalColors = 0;
    state.additionalColor = [];
    state.printedInstanceImage = [];
    state.DamageImage = [];
    state.CustomerOrderFormImage = [];
    state.UploadImageFile = [];
    state.totalImages = [];
    state.organizationUnitDescription.forSend = [];
    state.sampleInformation = {}










}

// 



const setLpi = (state, { payload }) => {
    // console.log(payload)
    let lpiListData = payload?.data.data;
    state.lpiList = lpiListData.map((lpi) => {
        return { key: lpi.lpi, value: lpi.id }
    })

}



// ///////////////////////////////////////////////////////////////////////////

const setOrganizationUnit = (state, { payload }) => {
    state.organizationUnit = payload
}





const setSepcialUnit = (state, { payload }) => {

    state.sepcialUnit = payload

}




const setUnitDescription = (state, { payload }) => {




    let title = '';
    state.sepcialUnit.forEach((unit) => {
        title += unit.key
        title += ' '
    })
    // onvan por shod

    state.unitDescription = payload;

    //tozihat por shod    

    let ids = state.sepcialUnit.map((unit) => {
        return unit.value
    })

    // listi az id vahedhaye mokhtalef gen shod


    let finalData = [];
    finalData.push({ id: uuid(), organizationUnits: [...ids], title: title, description: payload, descriptionType: ids.length > 1 ? 1 : 2 })
    // console.log(finalData)
    state.organizationUnitDescription.forSend = [...state.organizationUnitDescription.forSend, ...finalData]

}



const filterDescriptionChips = (state, { payload: id }) => {
    if (state.editMode) {
        state.editeModeData.departmanDescriptions = state.editeModeData.departmanDescriptions.filter(desc => desc.id !== id)
    } else {
        state.organizationUnitDescription.forSend = state.organizationUnitDescription.forSend.filter(desc => desc.id !== id)
    }
}

const filterAddedDepartmanDescription = (state, { payload: id }) => {

    state.editeModeData.addedDepartmanDescription = state.editeModeData.addedDepartmanDescription.filter(desc => desc.id !== id)

}





const setDepartmanDescriptions = (state, { payload }) => {
    //    let depsId=
    // console.log(payload)

    let title = '';
    state.sepcialUnit.forEach((unit) => {
        title += unit.key
        title += ' '
    }
    )
    state.unitDescription = payload;
    let ids = state.sepcialUnit.map((unit) => {
        return unit.value
    })
    let finalData = [];
    finalData.push({ id: uuid(), organizationUnits: [...ids], title: title, description: payload, descriptionType: ids.length > 1 ? 1 : 2 });

    // state.editeModeData.departmanDescriptions=[...state.editeModeData.departmanDescriptions,...finalData]
    state.editeModeData.addedDepartmanDescription = [...state.editeModeData.addedDepartmanDescription, ...finalData]

    // console.log(state.editeModeData.departmanDescriptions)
}




















const setCustomerMachineInfo = ({ customerMachinesInfo }, { payload }) => {
    let machinesRecived = payload;
    customerMachinesInfo.registredMachinesList = payload;

    customerMachinesInfo.machineNameList = machinesRecived.map((machine) => {
        return { key: machine.machineName, value: machine.id, numberOfColorDevice: machine.numberOfColorDevice };


    })

}



const setMachineSelectedInitial = ({ customerMachinesInfo }, { payload }) => {
    // console.log(payload)
    let { name, value } = payload
    if (name === 'machineInfoId') {
        customerMachinesInfo.machineSelected = customerMachinesInfo.registredMachinesList.find((machine) => machine.id === value)
    }

    customerMachinesInfo.orderMachineInfo[name] = value;



}


const setCustomerMachineDetails = ({ customerMachinesInfo }, { payload: machinDetails }) => {
    let aniloxInfoList = machinDetails.map((machine) => {
        return machine.aniloxInfoList
    })

    let cylinderInfoList = machinDetails.map((machine) => {
        return machine.cylinderInfoList
    })
    customerMachinesInfo.customerMachineDetails.aniloxInfoList = aniloxInfoList[0]
    customerMachinesInfo.customerMachineDetails.cylinderInfoList = cylinderInfoList[0]


}



const setCustomerIdForMachinInfo = ({ customerMachinesInfo }, { payload }) => {
    customerMachinesInfo.customerId = payload;

}



const setCustomerDesigner = ({ customerDesigner }, { payload }) => {
    customerDesigner.designerListName = payload
}




const setMachineName = ({ customerMachinesInfo }, { payload }) => {
    customerMachinesInfo.machineName = payload;
    // console.log(payload)
}

const setOrderViewData = (state, { payload }) => {
    state.orderViewData = payload;
}

const setSampleInformetion = ({ sampleInformation }, { payload }) => {

    let { name, value } = payload;
    // console.log(value)
    sampleInformation[name] = value;

}

const clearSampleInformation = (state) => {
    state.sampleInformation = {
        selectedDate: "",
        recipientUnitId: "",
        instanceCount: "",
        instanceDescription: "",
        printedInstanceKeepStatusId: "",
        printedInstanceTypeId: "",
        uploadImages: []
    }
}



const updateSampleInformation = (state, { payload }) => {
    let { name, value } = payload
    state.editeModeData.sampleInformation[name] = value
}


const clearAllColors = (state, { payload }) => {
    if (state.editMode) {
        state.editeModeData.colorSelections.forEach((color) => {
            color.countOfColor = 0;
        })
        state.editeModeData.colorDuplicated = [];
        state.editeModeData.additionalColorsDuplicated = [];


    } else {
        state.BasicColor.forEach((color) => {
            color.countOfColor = 0;
        })
        state.countOfTotalColors = 0;
        state.additionalColor = [];
    }
}



const updateMachineInfo = (state, { payload }) => {
    // console.log(payload)
    let { name, value } = payload;
    // if (payload.name==='machineInfoId') {
    //     state.editeModeData.machineInfo.orderAniloxes=[]
    // }

    state.editeModeData.machineInfo[name] = value;
}

const updateMachineName = ({ editeModeData }, { payload }) => {

    editeModeData.machineInfo.machineName = payload;
}

const setPreviousOrder = (state, { payload }) => {
    // console.log(payload)
    state.previousOrder = payload
}

// ///////////////////////////////////////////////////////////////////////////////////////////////////////////////


const setModeModule = (state, { payload }) => {
    // console.log(payload)
}


const setCustomerSendInfoList = (state, { payload }) => {
    // console.log(payload)
    state.customerSendInfoList = payload;
    state.customerslasticNumbers = payload?.map(({ id, elasticNumbers, receivesFileTypeId, customerAgreementTerms }) => {
        return { id: id, elasticNumbers: elasticNumbers, receivesFileTypeId: receivesFileTypeId, customerAgreementTerms: customerAgreementTerms }
    })

}


const setAniloxOrderColorMerged = (state, { payload }) => {
    // console.log(payload)
    state.aniloxOrderColorMerged = [...state.aniloxOrderColorMerged, payload]
}




const setAsyncOprationsMessages = (state, { payload }) => {
    // console.log(payload);

    let { messages, type } = payload;
    state.asyncOprationsMessages.errors = messages

}


const setAddOrderSuccessData = (state, { payload: orderSuccData }) => {
    if (orderSuccData && orderSuccData.data) {
        state.addOrderSuccessData = orderSuccData.data;
    } else {
        state.addOrderSuccessData = null;
    }
};


const setOrderColorForAnilox = (state, { payload }) => {
    // console.log(payload)
    state.orderColorsForAni = payload;

}

const updateOrderColorForAnilox = (state, { payload }) => {
    // console.log(payload)
    let { id, merged, aniId } = payload;
    let updated = { ...merged, aniluxId: merged.aniluxId };
    // console.log(updated);

    state.orderColorsForAni = state.orderColorsForAni.filter(item => item.id !== id);
    state.allMachineAnilox = state.allMachineAnilox.filter(item => item.id !== aniId);

    state.orderColorsForAni = [...state.orderColorsForAni, updated]
}



const restoreColorAnilox = (state, { payload }) => {
    // console.log(payload);
    let { cleared } = payload;
    // console.log(cleared)
    let { id, colorName, colorValue, colorId, uniqueId, aniluxId, aniloxType, degree, lpI_LPC, volume } = cleared;



    // console.log(cleared)

    let colorWithoutAni = {
        id: id,
        colorName: colorName,
        colorValue: colorValue,
        colorId: colorId,
    }



    let aniWithoutColor = {
        id: uuid(),
        aniluxId: aniluxId,
        aniloxType: aniloxType,
        degree: degree,
        lpI_LPC: lpI_LPC,
        volume: volume
    }

    // console.log(aniWithoutColor,colorWithoutAni);
    state.allMachineAnilox = [...state.allMachineAnilox, aniWithoutColor];

    state.orderColorsForAni = state.orderColorsForAni.filter(item => item.id !== id);
    state.orderColorsForAni = [...state.orderColorsForAni, colorWithoutAni];

}


const setAllMachineAnilox = (state, { payload: allAniloxs }) => {
    state.allMachineAnilox = allAniloxs;


}

const updateAllMachineAnilox = (state, { payload }) => {
    // console.log(id)
    // console.log(payload)
    state.allMachineAnilox = [...state.allMachineAnilox, payload]
}



const filterAllMachineAnilox = (state, { payload: id }) => {
    state.allMachineAnilox = state.allMachineAnilox.filter((item) => item.id !== id)
}







const setMachineAniloxSelected = (state, { payload: aniloxSelected }) => {
    //  console.log(aniloxSelected)
}



const resetAddedData = (state) => {
    state.addOrderSuccessData = null;

}


const setCustomerDeliverInfoList = (state, { payload }) => {
    // console.log(payload)
    state.customerDeliverInfoList = payload
}

const setUpdateColorState = (state) => {
    state.updateColorState = state.updateColorState + 1;
}














const OrderSlice = createSlice({
    name: 'Order',
    initialState,
    reducers: {
        setEditMode,
        setOrderSelected,
        addBasicColor,
        reduceBasicColor,
        addAdditionalColor,
        reduceAdditionalColor,
        setValueAdditionalColor,
        addCountOfAdditionalColor,
        reduceCountOfAdditionalColor,
        setTotalColors,
        clearAll,
        setImageFiles,
        deleteImage,
        setLpi,
        setOrganizationUnit,
        setUnitDescription,
        setSepcialUnit,
        filterDescriptionChips,
        setCustomerNamesForOrders,
        setCustomerKlischeThikness,
        setCustomerKlischeTypes,




        setCustomerMachineInfo,
        setMachineSelectedInitial,
        setCustomerMachineDetails,
        setCustomerIdForMachinInfo,
        setCustomerDesigner,
        setMachineName,
        // setOrderGeneratedNumber,



        setOrderViewData,
        setSampleInformetion,
        clearSampleInformation,
        clearAllAddedData,



        updateSampleInformation,
        clearAllColors,
        updateMachineInfo,
        updateMachineName,
        filterOrderImages,
        filterAddedImages,
        clearSampleInformationImages,
        setDepartmanDescriptions,
        filterAddedDepartmanDescription,
        setPreviousOrder,
        setModeModule,
        setCustomerSendInfoList,
        setAniloxOrderColorMerged,
        setAsyncOprationsMessages,
        setAddOrderSuccessData,
        setOrderColorForAnilox,
        updateOrderColorForAnilox,
        restoreColorAnilox,
        setAllMachineAnilox,
        filterAllMachineAnilox,
        setMachineAniloxSelected,
        updateAllMachineAnilox,
        resetAddedData,
        updateOrderCancelReasonInfo,
        setUpdateColorState,
        setOrderCancelData,
        setOrderDamageStatus



    }
})


export const {
    setEditMode: setEditModeR,
    setOrderSelected: setOrderSelectedR,
    addBasicColor: addBasicColorR,
    reduceBasicColor: reduceBasicColorR,
    addAdditionalColor: addAdditionalColorR,
    reduceAdditionalColor: reduceAdditionalColorR,
    setValueAdditionalColor: setValueAdditionalColorR,
    addCountOfAdditionalColor: addCountOfAdditionalColorR,
    reduceCountOfAdditionalColor: reduceCountOfAdditionalColorR,
    setTotalColors: setTotalColorsR,
    clearAll: clearAllR,
    setImageFiles: setImageFilesR,
    deleteImage: deleteImageR,
    setLpi: setLpiR,
    setOrganizationUnit: setOrganizationUnitR,
    setUnitDescription: setUnitDescriptionR,
    setSepcialUnit: setSepcialUnitR,

    filterDescriptionChips: filterDescriptionChipsR,
    setCustomerNamesForOrders: setCustomerNamesForOrdersR,
    setCustomerKlischeThikness: setCustomerKlischeThiknessR,
    setCustomerKlischeTypes: setCustomerKlischeTypesR,


    setCustomerMachineInfo: setCustomerMachineInfoR,
    setMachineSelectedInitial: setMachineSelectedInitialR,
    setCustomerMachineDetails: setCustomerMachineDetailsR,
    setCustomerIdForMachinInfo: setCustomerIdForMachinInfoR,
    setCustomerDesigner: setCustomerDesignerR,
    setMachineName: setMachineNameR,
    setOrderViewData: setOrderViewDataR,
    setSampleInformetion: setSampleInformetionR,
    clearSampleInformation: clearSampleInformationR,
    clearAllAddedData: clearAllAddedDataR,



    updateSampleInformation: updateSampleInformationR,
    filterOrderImages: filterOrderImagesR,
    filterAddedImages: filterAddedImagesR,
    updateMachineInfo: updateMachineInfoR,
    updateMachineName: updateMachineNameR,
    clearAllColors: clearAllColorsR,
    clearSampleInformationImages: clearSampleInformationImagesR,
    setDepartmanDescriptions: setDepartmanDescriptionsR,
    filterAddedDepartmanDescription: filterAddedDepartmanDescriptionR,
    setPreviousOrder: setPreviousOrderR,
    setCustomerSendInfoList: setCustomerSendInfoListR,



    // ///////////////////////////////////////////////////////////////////////////////////
    setModeModule: setModeModuleR,
    setAniloxOrderColorMerged: setAniloxOrderColorMergedR,
    setAsyncOprationsMessages: setAsyncOprationsMessagesR,
    setAddOrderSuccessData: setAddOrderSuccessDataR,
    setOrderColorForAnilox: setOrderColorForAniloxR,
    updateOrderColorForAnilox: updateOrderColorForAniloxR,
    restoreColorAnilox: restoreColorAniloxR,
    setAllMachineAnilox: setAllMachineAniloxR,
    setMachineAniloxSelected: setMachineAniloxSelectedR,
    updateAllMachineAnilox: updateAllMachineAniloxR,
    filterAllMachineAnilox: filterAllMachineAniloxR,
    resetAddedData: resetAddedDataR,
    setUpdateColorState: setUpdateColorStateR,
    updateOrderCancelReasonInfo:updateOrderCancelReasonInfoR,
    setOrderCancelData:setOrderCancelDataR,
    setOrderDamageStatus:setOrderDamageStatusR


} = OrderSlice.actions

export default OrderSlice.reducer